export function likeButtonClick(event, direction, icon, oIcon) {
  let thisLikeButton = event.currentTarget;
  let isActive = thisLikeButton.classList.contains('active');
  let thisButtonsThumbIcon = thisLikeButton.querySelector('i');
  let actionsDiv =  thisLikeButton.closest('div.actions');

  if(actionsDiv.dataset.requestInFlight !== 'true') {
    actionsDiv.dataset.requestInFlight = 'true';

    thisLikeButton.classList.add('click-enter-active');

    if(isActive) {
      thisLikeButton.classList.remove('active');
      thisButtonsThumbIcon.classList.remove(icon);
      thisButtonsThumbIcon.classList.add(oIcon);
    }
    else {
      thisLikeButton.classList.add('active');
      thisButtonsThumbIcon.classList.remove(oIcon);
      thisButtonsThumbIcon.classList.add(icon);
    }

    if(direction === 'up')
      inactivateThumbsDownButton(actionsDiv);
    else
      inactivateThumbsUpButton(actionsDiv);
  }
  else {
    event.preventDefault();
  }
}

function inactivateThumbsDownButton(actionsDiv) {
  let thumbsDownButton = actionsDiv.querySelector('button.link.down.active');

  if(thumbsDownButton) {
    let thumbIcon = thumbsDownButton.querySelector('i');

    thumbsDownButton.classList.remove('active');
    thumbsDownButton.classList.add('click-enter-active')
    thumbIcon.classList.remove('fa-thumbs-down');
    thumbIcon.classList.add('fa-thumbs-o-down');
  }
}

function inactivateThumbsUpButton(actionsDiv) {
  let thumbsUpButton = actionsDiv.querySelector('button.link.up.active');

  if(thumbsUpButton) {
    let thumbIcon = thumbsUpButton.querySelector('i');

    thumbsUpButton.classList.remove('active');
    thumbsUpButton.classList.add('click-enter-active')
    thumbIcon.classList.remove('fa-thumbs-up');
    thumbIcon.classList.add('fa-thumbs-o-up');
  }
}
